import { render } from "./MobileAppAndWebsite.vue?vue&type=template&id=5d634289"
import script from "./MobileAppAndWebsite.vue?vue&type=script&lang=js"
export * from "./MobileAppAndWebsite.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__